import { render, staticRenderFns } from "./NewVideoInterests.vue?vue&type=template&id=e13163fa&scoped=true&"
import script from "./NewVideoInterests.vue?vue&type=script&lang=js&"
export * from "./NewVideoInterests.vue?vue&type=script&lang=js&"
import style0 from "./NewVideoInterests.vue?vue&type=style&index=0&id=e13163fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13163fa",
  null
  
)

export default component.exports